<div data-test="qcrP2LrP" [ngClass]="{ 'tabs-bg text-left': separate, tabs: !separate }">
  <div
    data-test="G7Jcex3w"
    [ngClass]="{ 'tabs-bg__wrap': separate, tabs__wrap: !separate }"
  >
    <ng-content></ng-content>
  </div>
</div>
